import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  scales: {
    x: {
      border: {
        display: false,
      },
    },
  },
  indexAxis: "y",
  elements: {
    bar: {
      width: 35,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },
};

function HorizontalBar({ advance_stat }) {
  const data = {
    labels: advance_stat.labels,
    datasets: [
      {
        data: advance_stat.data,
        backgroundColor: "#3a86ff",
        barThickness: 25,
      },
    ],
  };
  return <Bar options={options} data={data} />;
}

export default HorizontalBar;
